import { CloudImage } from "@/components/CloudImage";

// Immagine di una "card" (categoria/marchio) con zoom e posizione regolabili
// dall'admin. Recupera l'immagine senza pre-ritaglio così la posizione CSS
// (object-position) e lo zoom (scale) funzionano correttamente.
export function TileImage({ url, alt, scale = 1, fit = "cover", posX = 50, posY = 50, className = "" }) {
  if (!url) return null;
  const cover = fit !== "contain";
  return (
    <CloudImage
      url={url}
      alt={alt}
      transform="c_limit,w_1000,f_auto,q_auto"
      loading="lazy"
      className={`absolute inset-0 h-full w-full ${cover ? "object-cover" : "object-contain"} ${className}`}
      style={{
        objectPosition: `${posX}% ${posY}%`,
        transform: `scale(${Number(scale) || 1})`,
        transformOrigin: `${posX}% ${posY}%`,
      }}
    />
  );
}
